export default __webpack_public_path__ + "static/media/Websources_result_02.e52f6678.png";